import React from "react";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import useHasPermission from "hooks/useHasPermission";

const ReturnPolicyTable = ({
  policyData,
  onEdit,
}: {
  policyData?: {
    returnDays: number;
    exchangeDays: number;
    buybackAfter: number;
  };
  onEdit?: () => void;

}) => {
  const hasPermission = useHasPermission();

  return (
    <div className="bg-white rounded-4 shadow-sm p-3">
      <h5 className="fw-bold mb-3">
        Policy Setting
      </h5>

      <p>The Policy Setting defines the timelines for customer actions after a purchase  products can be returned within the specified number of days from the purchase date, exchanged after a certain period as per eligibility, and offered for buyback after the defined duration, allowing customers to sell the product back to the store with predetermined deductions.
      </p>

      <Table bordered responsive className="mb-0">
        <thead>
          <tr className="text-white" style={{ backgroundColor: "#b7002a" }}>
            <th className="text-white" style={{ width: "60px" }}>Action</th>
            <th className="text-white">Return (within) - {policyData?.returnDays}</th>
            <th className="text-white">Exchange (After) - {policyData?.exchangeDays}</th>
            <th className="text-white">Buyback (After) - {policyData?.buybackAfter}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center">
              {hasPermission('StorePolicy.Write') && <button
                className="btn btn-sm action-btn edit-btn"
                title="Update"
                onClick={onEdit}
              >
                <FontAwesomeIcon icon={faPenToSquare} />
              </button>}
            </td>
            <td>{policyData?.returnDays}</td>
            <td>{policyData?.exchangeDays}</td>
            <td>{policyData?.buybackAfter}</td>

          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default ReturnPolicyTable;
